import {asyncActionGenerator, plainActionGenerator} from 'utils';

export const loginAsyncActions = asyncActionGenerator('LOGIN')

export const logoutAction = plainActionGenerator('LOGOUT');